import {FC} from 'react';

import {BaseModalProps} from './parts/BaseModal/types';
import {ModalControlledProps} from './parts/ModalControlled/types';
import {ModalControlled} from './parts/ModalControlled/ModalControlled';
import BaseModal from './parts/BaseModal/BaseModal';

/*
  Для установки подходящего размера на десктопе нужнно установить flex-basis и max-width
  Есть mixin: @include desktopModalMaxSize(720px);
 */

type ModalProps = BaseModalProps | ModalControlledProps;

export const Modal: FC<ModalProps> = (props) => {
  // Check we need redux modal or controled by props
  if ('id' in props) {
    return <ModalControlled {...props} />;
  }

  return <BaseModal {...props} />;
};
